import { render, staticRenderFns } from "./updateInfoBankAffiliate.vue?vue&type=template&id=831bb2c2&scoped=true"
import script from "./updateInfoBankAffiliate.vue?vue&type=script&lang=js"
export * from "./updateInfoBankAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831bb2c2",
  null
  
)

export default component.exports